module.exports = __webpack_public_path__ + "static/media/Begeleider-en-voertuig_2.8262c5a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/chapters/02/03/components/c02_a03_tab_02/assets/Begeleider-en-voertuig_2.jpg
// module id = 790
// module chunks = 0